"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readHierarchyPhysicalNetNames = readHierarchyPhysicalNetNames;
const OrcadDsnCfbStreamUtils_1 = require("./OrcadDsnCfbStreamUtils");
function readHierarchyPhysicalNetNames(bytes, viewName, streamPath, diagnostics) {
    const records = [];
    OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.forEachTerminatedPayload(bytes, (record) => records.push(record));
    const fail = (reason, offset) => {
        diagnostics.push({
            severity: 'warning',
            code: 'hierarchy-physical-name-frame-withheld',
            streamPath,
            offset,
            message: `CFB physical net name [hierarchy-physical-name-frame-withheld] view=${JSON.stringify(viewName)} reason=${reason} offset=${offset}`,
        });
        return [];
    };
    const header = records[0];
    if (!header || header.offset !== 0 || bytes[0] !== 0x42 || header.byteLength === header.payloadByteLength) {
        return fail('root-header-unframed', 0);
    }
    const name = countedName(bytes, header, 9);
    if (!name || name.value.toUpperCase() !== viewName.toUpperCase()) {
        return fail('root-view-mismatch', 9);
    }
    let record = header;
    let cursor = name.after + 7;
    let index = 1;
    if (cursor + 2 > record.offset + record.payloadByteLength) {
        return fail('port-count-truncated', cursor);
    }
    const portCount = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt16LE(bytes, cursor);
    cursor += 2;
    for (let port = 0; port < portCount; port++) {
        if (!tableFrame(bytes, record, cursor, 0x44)) {
            return fail('port-frame-unresolved', cursor);
        }
        const next = records[index++];
        if (!next) {
            return fail('port-record-missing', cursor);
        }
        record = next;
        const field = countedName(bytes, record, record.offset + 4);
        if (!field) {
            return fail('port-name-truncated', record.offset);
        }
        cursor = field.after;
    }
    if (cursor + 2 > record.offset + record.payloadByteLength) {
        return fail('net-count-truncated', cursor);
    }
    const count = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt16LE(bytes, cursor);
    cursor += 2;
    const names = [];
    for (let net = 0; net < count; net++) {
        if (!tableFrame(bytes, record, cursor, 0x43)) {
            return fail('net-frame-unresolved', cursor);
        }
        const next = records[index++];
        if (!next || next.byteLength === next.payloadByteLength) {
            return fail('net-record-unclosed', cursor);
        }
        record = next;
        const field = countedName(bytes, record, record.offset + 4);
        if (!field) {
            return fail('net-name-truncated', record.offset);
        }
        names.push(field.value);
        cursor = field.after;
    }
    if (tableFrame(bytes, record, cursor, 0x43)) {
        return fail('net-count-mismatch', cursor);
    }
    return names;
}
function countedName(bytes, record, offset) {
    const end = record.offset + record.payloadByteLength;
    if (offset + 2 > end) {
        return undefined;
    }
    const length = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt16LE(bytes, offset);
    const after = offset + 2 + length;
    if (after >= end || bytes[after] !== 0) {
        return undefined;
    }
    const valueBytes = bytes.subarray(offset + 2, after);
    if (valueBytes.some((byte) => byte < 0x20)) {
        return undefined;
    }
    return { value: Array.from(valueBytes, (byte) => String.fromCharCode(byte)).join(''), after: after + 1 };
}
function tableFrame(bytes, record, offset, kind) {
    const end = record.offset + record.payloadByteLength;
    if (record.byteLength === record.payloadByteLength ||
        offset + 12 > end ||
        bytes[offset] !== kind ||
        bytes[offset + 9] !== kind) {
        return false;
    }
    const length = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt32LE(bytes, offset + 1);
    const count = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt16LE(bytes, offset + 10);
    return length === 11 + 8 * count && offset + length + 1 === end;
}
//# sourceMappingURL=OrcadDsnCfbHierarchyPhysicalNames.js.map